<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="custom_card fadeIn" v-else>
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <upload-image-direct
              @loading="btnIsLoading = $event"
              @inputChanged="uplodeImg_1"
              :data_src="data.preview"
              placeHolder="صورة القسم"
              model="place_categories"
            ></upload-image-direct>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0" v-if="rows.length">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.key") }}
                </label>
                <multiselect
                  v-model="data.myKey"
                  :options="rows"
                  label="name"
                  track-by="name"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.priority") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  rows="5"
                  v-model="data.priority"
                />
              </div>
            </div>
            <!-- Start:: Is Grid -->
            <div class="col-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_grid')"
                v-model="data.is_grid"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Grid -->

            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  class="form-control"
                  rows="5"
                  v-model="data.en.desc"
                ></textarea>
              </div>
            </div> -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.categories.title"),
          disabled: false,
          href: "/store_category/show-all",
        },
        {
          text: this.$t("breadcrumb.categories.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      rows: [],
      // ========== create_data
      data: {
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        preview: null,
        myKey: null,
        image: null,
        priority: null,
        is_grid: false,
      },
    };
  },

  methods: {
    // Uplode Image

    uplodeImg_1(obj) {
      console.log(obj);
      this.data.image = obj;
    },
    getKeys() {
      this.$axios({
        method: "GET",
        url: `get_category_keys`,
      })
        .then((res) => {
          this.rows = res.data.data.map((el) => {
            return {
              id: el.id,
              name: el.ar.name,
            };
          });
          this.getData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        //   else if (!this.data.en.desc) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: this.$t("forms.validation.desc_en"),
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
        // } else if (!this.data.ar.desc) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: this.$t("forms.validation.desc_ar"),
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
        // }
      } else if (this.data.priority === null || this.data.priority === "") {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.priority"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.myKey?.id) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجى اختيار التصنيف",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;

      const submit_data = new FormData();
      if (this.data.image) {
        submit_data.append("image", this.data.image);
      }
      submit_data.append("ar[name]", this.data.ar.name);
      // submit_data.append("ar[description]", this.data.ar.desc);
      submit_data.append("en[name]", this.data.en.name);
      // submit_data.append("en[description]", this.data.en.desc);
      submit_data.append("priority", this.data.priority);
      submit_data.append("key", this.data.myKey?.id);
      submit_data.append("is_grid", +this.data.is_grid);

      submit_data.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `store_category/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });

          this.$router.push({ path: "/store_category/show-all" });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    getData() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `store_category/${this.id}`,
      }).then((res) => {
        this.loading = false;

        this.data.myKey = this.rows.find((el) => el.id == res.data.data.key);
        this.data.ar.name = res.data.data.ar.name;
        this.data.ar.desc = res.data.data.ar.description;
        this.data.en.name = res.data.data.en.name;
        this.data.en.desc = res.data.data.en.description;
        this.data.preview = res.data.data.image;
        this.data.priority = res.data.data.priority;
        this.data.is_grid = res.data.data.is_grid;
      });
    },
  },

  mounted() {
    // this.getData();
    this.getKeys();
  },
};
</script>
